var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size * 11 / 6,"viewBox":"0 0 6 11"}},[_c('g',[_c('path',{attrs:{"fill":_vm.color,"d":"M5.723 5.311L1.465 1.04a.616.616 0 0 0-.86 0 .616.616 0 0 0 0 .86L4.44 5.734.604 9.57a.616.616 0 0 0 0 .86.616.616 0 0 0 .86 0l4.26-4.258a.616.616 0 0 0 0-.86z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }